var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Big_Talk"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.5998 43.148H38.5791C34.3143 43.0445 30.7016 40.9639 29.1592 37.7031C28.89 37.1234 28.683 36.523 28.5484 35.902C28.0309 35.902 27.0371 35.902 24.6666 35.902H17.6275C7.94884 35.9123 0.0816509 28.0865 0.0712993 18.3975C0.0609478 8.7084 7.88673 0.861914 17.5654 0.851562C17.5861 0.851562 17.5965 0.851562 17.6172 0.851562H28.3828C38.0615 0.851562 45.908 8.69805 45.908 18.3768C45.908 24.0184 43.1856 29.3184 38.6102 32.6102C37.6578 33.2623 37.016 34.2768 36.8608 35.4154C36.7883 36.0986 36.809 36.8025 36.9332 37.4754C37.2334 39.0902 38.0201 40.5705 39.1899 41.7299C39.5107 42.0508 39.5107 42.5787 39.1899 42.8996C39.0242 43.0652 38.8172 43.148 38.5998 43.148ZM28.5588 34.2457C29.3352 34.2457 30.008 34.7943 30.1736 35.5603C30.2772 36.0572 30.4428 36.5437 30.6602 36.9992C31.8817 39.3076 34.1279 40.9018 36.7055 41.2848C36.0016 40.2186 35.5254 39.0281 35.308 37.7652C35.1631 36.9268 35.132 36.0779 35.2252 35.2395C35.4322 33.6246 36.3225 32.1857 37.6578 31.2645C44.7797 26.1508 46.4049 16.234 41.2912 9.11211C38.2893 4.96113 33.4965 2.50781 28.3828 2.50781H17.6172C8.84942 2.50781 1.74825 9.61934 1.74825 18.3871C1.74825 27.1549 8.85978 34.2561 17.6275 34.2561H24.6666C27.0475 34.2561 28.0309 34.2561 28.5381 34.2561L28.5588 34.2457Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2);
export default __webpack_public_path__ + "static/media/s2.bf5023ef620c9d7323a709b0b6a55943.svg";
export { ForwardRef as ReactComponent };